import { Avatar } from '@mui/material'
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome'

/**
 * Grey circular avatar with the assistant icon, used in chat bubbles and the typing indicator.
 */
const AssistantAvatar = () => (
  <Avatar sx={{ width: 32, height: 32, backgroundColor: 'grey.300', flexShrink: 0 }}>
    <AutoAwesomeIcon sx={{ fontSize: 18, color: 'grey.700' }} />
  </Avatar>
)

export default AssistantAvatar
